/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:50:24
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-08-11 20:10:34
 */
import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuComponent } from '../menu.component';
import { MenuOption, MenuItem } from '../model';

@Component({
  selector: 'ad-section-menu-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements OnInit {
  menus: MenuItem[];
  menuClass: string;
  options: MenuOption;
  @Input() set option(val: MenuOption) {
    if (!this.checkObjectIsDefined(val)) {
      return;
    }
    this.options = val;
    if (this.checkStringIsDefinfed(this.options.branding)) {
      this.menuClass = 'ad-menu-default ad-menu-' + this.options.branding;
    } else {
      this.menuClass = 'ad-menu-default';
    }
    this.menus = this.options.menus;
    this.setSelectedMenu();
  }
  selectedMenu: MenuItem;

  constructor(private router: Router, public wrapper: MenuComponent) {}

  checkStringIsDefinfed(str: string): boolean {
    return this.checkObjectIsDefined(str) && str !== '';
  }

  checkObjectIsDefined(obj: any): boolean {
    if (obj === undefined || obj === null) {
      return false;
    }
    return true;
  }

  clickMenu(e: Event, menu: MenuItem): void {
    e.preventDefault();
    //e.stopPropagation();
    if (menu.isExternal === false) {
      this.router.navigate([menu.link]);
    } else {
      location.href = menu.link;
    }
  }

  ngOnInit(): void {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.setSelectedMenu();
      }
    });
  }

  setSelectedMenu(): void {
    this.menus.forEach((menu) => {
      if (
        this.router.url.indexOf(menu.link) === 1
      ) {
        this.selectedMenu = menu;
      }
    });
  }
}
